module.exports = __webpack_public_path__ + "img/berlinerkranse_dej_cool.44edfa12.jpg";